// eslint-disable-next-line import/prefer-default-export
export function resolve(basePath: string, path: string) {
  if (path?.startsWith('/')) {
    return path;
  }
  const base = basePath?.replace(/\/+$/, '') ?? '';
  const p = path?.replace(/^\/+/, '') ?? '';
  return `${base}/${p}`;
}
